import { List as ImmutableList } from 'immutable';
import { getFirstName } from 'conversations-internal-schema/responders/operators/responderGetters';
/**
 * @temporary Remove/modify this once the backend handles system/integration users server side.
 * @expiration 2026-04-11
 * @deprecated
 */
const SYSTEM_USER_FIRST_NAME_PATTERN = /App \d+ \(HubSpot connector for .*?\)/i;
export const isSystemUserResponder = responder => {
  const firstName = getFirstName(responder);
  return !!(firstName && SYSTEM_USER_FIRST_NAME_PATTERN.test(firstName));
};
export const filterSystemUserResponders = responders => {
  return ImmutableList(responders.filter(responder => !isSystemUserResponder(responder)));
};